import { useMemo } from "react";
import {
    atpProvidersOptions,
    insideClinicOptions,
    nextgenDiagnosticServicesOptionsSimple,
    nextgenReferralServicesOptionsSimple,
    outsideClinicOptions,
} from "../../../../../lib/systemData";
import DateDisplayWithNmuberOfDays from "../../../../common/DateDisplayWithNmuberOfDays";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";

const escapeRegex = (value) => {
    return `${value}`.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const descriptionHasWholeWord = (description, word) => {
    if (!description || !word) {
        return false;
    }
    const escapedWord = escapeRegex(word.trim());
    if (!escapedWord) {
        return false;
    }
    const regex = new RegExp(`(^|[^a-zA-Z])${escapedWord}([^a-zA-Z]|$)`, "i");
    return regex.test(description);
};

export default function ServicesSection({
    classes,
    column,
    drawerData = {},
    goToCaseTabHandler,
    applyHiddenDefaultFilters = false,
}) {
    const displayedServices = useMemo(() => {
        const services = Array.isArray(drawerData?.services) ? drawerData.services : [];

        const filtered =
            applyHiddenDefaultFilters
                ? (() => {
                      const diagTokens = nextgenDiagnosticServicesOptionsSimple() || [];
                      const referralTokens = nextgenReferralServicesOptionsSimple() || [];

                      const diag =
                          diagTokens.length > 0
                              ? services.filter(
                                    (item) =>
                                        item?.class === "DIAG" &&
                                        diagTokens.some((token) => descriptionHasWholeWord(item?.description, token)),
                                )
                              : [];

                      const referrals =
                          referralTokens.length > 0
                              ? services.filter(
                                    (item) =>
                                        item?.class !== "DIAG" &&
                                        referralTokens.some((token) => descriptionHasWholeWord(item?.description, token)),
                                )
                              : [];

                      // Merge unique by id, preserve original order where possible.
                      return [
                          ...new Map([...diag, ...referrals].map((item) => [item?.id, item])).values(),
                      ].filter(Boolean);
                  })()
                : services;

        return [...filtered].sort((a, b) => new Date(b.date_ordered) - new Date(a.date_ordered));
    }, [drawerData?.services, applyHiddenDefaultFilters]);

    const providerLabelMap = useMemo(() => {
        const list = atpProvidersOptions() || []
        return new Map(list.map((item) => [String(item.value), item.label]))
    }, [])

    const outsideClinicLabelMap = useMemo(() => {
        const list = outsideClinicOptions() || []
        return new Map(list.map((item) => [String(item.value), item.label]))
    }, [])

    const insideClinicLabelMap = useMemo(() => {
        const list = insideClinicOptions() || []
        return new Map(list.map((item) => [String(item.value), item.label]))
    }, [])

    const providerLabel = (value) => providerLabelMap.get(String(value)) || null
    const outsideClinicLabel = (value) => outsideClinicLabelMap.get(String(value)) || null
    const insideClinicLabel = (value) => insideClinicLabelMap.get(String(value)) || null

    return (
        <div className={`${classes.block} ${classes[`block_${column}`]}`}>
            <div className={classes.block_header}>
            <h3>Services</h3>
                <button onClick={goToCaseTabHandler.bind(this, 9)}><i className='ti ti ti-arrow-up-right'></i></button>
            </div>
            <div className={classes.overflow_container}>
                <table className={`${classes.table_services} table-border-radius-8`}>
                    <thead>
                        <tr>
                            <th className="table-cell-fit">Date Ordered</th>
                            <th>Ordered by</th>
                            <th>Class</th>
                            <th style={{width: 400}}>Area/Description</th>
                            {/* <th>Diagnosis</th> */}
                            <th className="table-cell-fit">Outside</th>
                            <th>Clinic</th>
                            <th>Provider</th>
                            <th className="table-cell-fit">Completed date</th>
                        </tr>
                    </thead>
                    <tbody>
                            {displayedServices.map(serviceItem => (  
                                // <ServicesItem key={serviceItem.id} itemData={serviceItem} />
                                <tr key={serviceItem.id}>
                                    <td>
                                        <DateDisplayWithNmuberOfDays date={serviceItem.date_ordered} textRight={true}/>
                                    </td>

                                    <td className="table-cell-fit">
                                        {serviceItem.order_by_id && <>
                                            {providerLabel(serviceItem.order_by_id)}
                                        </>}
                                    </td>

                                    <td className="table-cell-fit">{serviceItem.class}</td>

                                    <td style={{paddingTop: 2, paddingBottom: 2}}>{serviceItem.description}</td>

                                    <td>
                                        <CheckboxCell checked={serviceItem.is_outside_clinic} isDisabled={true} identifier={{type: 'case_services', field: 'is_outside_clinic', type_id: serviceItem.id, folder: 'services'}} setStyle={'centered'}/>
                                    </td>
                                    {/* <td>{serviceItem.outside}</td> */}
                                    <td>
                                    {serviceItem.is_outside_clinic ? 
                                        // <CustomSelectGrouped optionsData={practicesLocationsGroupedOptions()} preSelectedValue={itemData.outside_location_id} action={updateHandlerAlternative} name={'location'} identifier={{type: 'case_services', field: 'outside_location_id', type_id: itemData.id, folder: 'services'}} sameSizeAsContainer={true} hasRemove={true}/>
                                        <>
                                        {outsideClinicLabel(serviceItem.outside_location_id)}
                                        </>
                                        // <CustomSelect optionsData={outsideClinicOptions()} preSelectedValue={itemData?.outside_location_id} action={updateHandlerAlternative} identifier={{type: 'case_services', field: 'outside_location_id', type_id: itemData.id, folder: 'services'}} sameSizeAsContainer={true} hasRemove={true}/>
                                        :
                                        <>
                                        {insideClinicLabel(serviceItem.practice_id)}
                                        </>
                                        // <CustomSelect optionsData={insideClinicOptions()} preSelectedValue={itemData?.practice_id} action={updateHandlerAlternative} identifier={{type: 'case_services', field: 'practice_id', type_id: itemData.id, folder: 'services'}} sameSizeAsContainer={true} hasRemove={true}/>
                                        }
                                    </td>
                                    <td>
                                    {serviceItem.is_outside_clinic ?
                                        <>{serviceItem.outside_provider}</>
                                        // <InputBox bkTransparent={true} currentValue={serviceItem?.outside_provider} action={updateHandlerAlternative} identifier={{type: 'case_services', field: 'outside_provider', type_id: serviceItem.id, folder: 'services'}} setStyle={'simple'}/>
                                        :
                                        <>{providerLabel(serviceItem.provider_id)}</>
                                        // <CustomSelect optionsData={atpProvidersOptions()} preSelectedValue={serviceItem?.provider_id} action={updateHandlerAlternative} identifier={{type: 'case_services', field: 'provider_id', type_id: serviceItem.id, folder: 'services'}} sameSizeAsContainer={true} hasRemove={true}/>       
                                    }
                                    </td>
                                    <td>
                                        <DateDisplayWithNmuberOfDays date={serviceItem.completed_date} textRight={true}/>
                                    </td>
                                </tr>
                            ))}
                            
                            {(!displayedServices || displayedServices.length == 0) && <tr>
                                <td colSpan="11">No results found!</td>
                            </tr>}
                    </tbody>
                </table>
            </div>
        </div>
    )
}